import { Box, Stack, Text } from '@chakra-ui/react'
import { faBadge } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import chakraTokenToVar from '@/utils/chakraTokenToVar'
import { pluralize } from '@/utils/helpers'
import { FONT_FAMILY } from '@/constants/constants'

import UserQ from '@/queries/UserQ'
import UserVolunteerRoleQ from '@/queries/UserVolunteerRoleQ'
import type { Query } from '@/client/query'

export default function UserBadgesCount({
  user,
  variant = 'small',
  hideText = false,
}: {
  user: Query
  variant?: 'big' | 'small'
  hideText?: boolean
}): JSX.Element {
  const badges = Object.keys(user(UserQ.progression)?.achievements ?? {}).length
  const numVolunteerRoles = user`COUNT(*) ${UserVolunteerRoleQ.where({ userId: UserQ.id })}` ?? 0
  const badgeCount = badges + numVolunteerRoles
  return (
    <Stack direction="row" spacing="2px" align="center" as="a" textDecoration="none">
      <Box w={variant === 'big' ? '36px' : '20px'} fontSize={variant === 'big' ? '24px' : '14px'}>
        <FontAwesomeIcon icon={faBadge} color={chakraTokenToVar('yellow.solid')} />
      </Box>
      <Text
        fontFamily={variant === 'big' ? FONT_FAMILY.default : FONT_FAMILY.heading}
        fontSize={variant === 'big' ? '20px' : '13px'}
        fontWeight="bold"
      >
        {hideText ? badgeCount : pluralize(badgeCount, 'Badge')}
      </Text>
    </Stack>
  )
}
